import { IActivity } from '../../../../../../../../../../../store/features/activity/interface/IActivityList'
import { IAppointmentActivity } from '../../../../../../../../../../../store/features/calendar/interface/appointment/IAppointmentActivity'
import { IPerson } from '../../../../../../../../../../../store/features/person/interface/IPerson'
import { IAddedActivity } from '../../../components/AddActivityViewSwitch/IAddActivity'
import { findPersonUuid } from '../findUuid/findPersonUuid'
import { IAddedActivitiesByKey } from './IAddedActivitiesByKey'

export const checkIfMultiPersonActivity = (
  appointmentActivities: IAppointmentActivity[],
  activityList: IActivity[],
  personList: IPerson[]
): IAddedActivity[] => {
  // eslint-disable-next-line max-len
  const addedActivities: IAddedActivitiesByKey =
    appointmentActivities.reduce<IAddedActivitiesByKey>(
      (accObject, appointmentActivity) => {
        const activityKey: `${number}_${string}` = `${parseInt(
          appointmentActivity.startsAt.format('hhmm'),
          10
        )}_${appointmentActivity.activityId}`
        if (!(activityKey in accObject)) {
          const activity = activityList.find(
            (oneActivity) => oneActivity.id === appointmentActivity.activityId
          )
          if (!activity) {
            return accObject
          }

          // eslint-disable-next-line no-param-reassign
          accObject[activityKey] = {
            activity: activity,
            isLocked: appointmentActivity.isLocked,
            personUuids: [],
            appointmentActivityUuid:
              appointmentActivity.appointmentActivityUuid,
            appointmentActivityId: appointmentActivity.id,
          }
        }

        accObject[activityKey].personUuids.push(
          findPersonUuid(personList, appointmentActivity.personId)
        )

        return accObject
      },
      {}
    )

  return Object.values(addedActivities)
}
